class SizeGuideDrawer extends HTMLElement {
    constructor() {
        super();

        const link = document.querySelector(".size-guide-link");
        const drawer = this.querySelector(".drawer");
        const overlay = this.querySelector(".overlay");
        const closeBtn = this.querySelector(".close-btn");

        const open = () => {
            drawer.classList.add("active");
            overlay.classList.add("active");
            document.body.style.overflow = "hidden";
        };

        const close = () => {
            drawer.classList.remove("active");
            overlay.classList.remove("active");
            document.body.style.overflow = "";
        };

        link.addEventListener("click", open);
        closeBtn.addEventListener("click", close);
        overlay.addEventListener("click", close);
    }
}

customElements.define("size-guide-drawer", SizeGuideDrawer);